import React, { useState, useRef, useEffect } from "react";

// Snooping on my website ? These keys won't do anything cool for YOU. :P

const ACCESS = {
  // keena
  "c356d8945226f7bf825a2f41dce3d8bf26e05c0f61afe42d3b9cd221469e72c2":
    { host: "K334A-LAPTOP:/$", gold: false },
  // juan
  "7f6876b4d50d8f8278f1611b2957d13c6d7168c601cee68972176af9b1ef646f":
    { host: "JUAN-MINI:/$", gold: true },
};

async function sha256(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
}
if (typeof window !== "undefined") window.sha256 = sha256; // for hashing in the console

const STAR = "M50 4 L61 37 L96 37 L68 58 L79 94 L50 72 L21 94 L32 58 L4 37 L39 37 Z";
const STAR2 = "M50 6 L60 38 L94 38 L66 58 L77 92 L50 71 L23 92 L34 58 L6 38 L40 38 Z";
const HEART =
  "M50 86 C18 60 8 44 8 28 C8 14 22 8 33 16 C40 21 50 33 50 33 C50 33 60 21 67 16 C78 8 92 14 92 28 C92 44 82 60 50 86 Z";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&family=Silkscreen:wght@400;700&display=swap');

.tat-root{
  --pink:#f3a6b6; --pink-soft:#f6bcc8;
  --title:#f06d92; --title-shadow:#cf4f76;
  --ink:#211e1a; --line:#16140f;
  --term-bg:#51512e; --term-host:#ef6d99; --term-host2:#e7c069; --term-cmd:#f3aebd;
  background:var(--pink); color:var(--ink); min-height:100vh;
  font-family:"Silkscreen",monospace; -webkit-font-smoothing:none;
  image-rendering:pixelated; text-transform:uppercase;
  line-height:1.7; letter-spacing:.02em; padding:34px 26px 40px; box-sizing:border-box;
}
.tat-root *{ box-sizing:border-box; }

.tat-layout{ max-width:560px; margin:0 auto; position:relative; }
.tat-page{ width:100%; max-width:560px; }

.tat-root h1{
  font-family:"Press Start 2P",monospace; font-size:30px; line-height:1;
  color:var(--title); text-shadow:3px 3px 0 var(--title-shadow);
  margin:0 0 26px; letter-spacing:.02em;
}
.tat-intro{ max-width:480px; }
.tat-intro p{ font-size:11px; margin:0 0 16px; line-height:1.75; }

.tat-frames{ display:grid; grid-template-columns:1fr 1fr; gap:34px; margin:40px 0 30px; }
.tat-moment{ min-width:0; }
.tat-canvas{ position:relative; aspect-ratio:1/1; border:2px solid var(--line); background:var(--pink); }
/* Fills the square exactly; doodles come later in the DOM so they overhang on top.
   image-rendering:auto overrides the pixelated value inherited from .tat-root.
   Change it to pixelated if you want the photo crunchy like the rest of the page.
   NOTE: this CSS lives in a JS template literal — no backticks in here. */
.tat-photo{ position:absolute; inset:0; width:100%; height:100%;
  object-fit:cover; display:block; image-rendering:auto; }
.tat-doodle{ position:absolute; overflow:visible; }
.tat-doodle svg{ display:block; }
.tat-doodle path{ fill:none; stroke:var(--line); stroke-width:2.4; stroke-linejoin:round; stroke-linecap:round; }
.tat-star-big{ top:-30px; right:-22px; width:78px; height:78px; transform:rotate(6deg); }
.tat-star-small{ left:-26px; bottom:-18px; width:54px; height:54px; transform:rotate(-12deg); }
.tat-heart-tl{ top:-30px; left:-16px; width:62px; height:62px; transform:rotate(-6deg); }
.tat-heart-br{ bottom:-26px; right:-14px; width:58px; height:58px; transform:rotate(8deg); }

.tat-label{ margin-top:14px; font-size:11px; font-weight:700; }
.tat-seen{ display:inline-block; margin-top:2px; font-size:11px; background:none; border:none;
  padding:0; font:inherit; color:inherit; text-transform:uppercase; cursor:pointer; letter-spacing:.02em; }
.tat-seen:hover .tat-box{ color:var(--title); }
.tat-seen:focus-visible{ outline:2px solid var(--line); outline-offset:3px; }

.tat-terminal{
  margin-top:38px; border:2px solid var(--line); background:var(--term-bg);
  padding:16px 18px 18px; font-size:11px; line-height:1.9; letter-spacing:.04em;
  height:300px; display:flex; flex-direction:column;
}
.tat-log{ flex:1 1 auto; min-height:0; overflow-y:auto; overscroll-behavior:contain;
  scrollbar-width:thin; scrollbar-color:var(--term-host) var(--term-bg); }
.tat-log::-webkit-scrollbar{ width:9px; }
.tat-log::-webkit-scrollbar-track{ background:transparent; }
.tat-log::-webkit-scrollbar-thumb{ background:var(--term-host); border:2px solid var(--term-bg); }
.tat-host{ color:var(--term-host); }
.tat-host2{ color:var(--term-host2); }
.tat-cmd{ color:var(--term-cmd); }

.tat-entry{ flex:none; display:flex; align-items:baseline; gap:7px; padding-top:8px; }
.tat-entry .tat-host{ white-space:nowrap; }
.tat-entry input{ flex:1 1 auto; min-width:0; background:none; border:none; outline:none;
  font:inherit; text-transform:uppercase; letter-spacing:inherit;
  color:var(--term-cmd); caret-color:var(--term-cmd); padding:0; }

.tat-lock{ position:fixed; inset:0; z-index:100; background:var(--term-bg); color:var(--term-cmd);
  display:flex; flex-direction:column; justify-content:center; align-items:flex-start;
  gap:14px; padding:30px 26px; font-size:12px; line-height:1.8; letter-spacing:.04em;
  text-transform:uppercase; font-family:"Silkscreen",monospace; -webkit-font-smoothing:none; }
.tat-lk-title{ font-family:"Press Start 2P",monospace; font-size:16px; color:var(--term-host);
  text-shadow:2px 2px 0 var(--title-shadow); margin-bottom:6px; }
.tat-lk-prompt{ display:flex; align-items:baseline; gap:8px; width:min(440px,100%); }
.tat-lk-prompt .tat-host{ white-space:nowrap; }
.tat-lock input{ flex:1 1 auto; min-width:0; background:none; border:none; outline:none;
  font:inherit; letter-spacing:inherit; color:var(--term-cmd); caret-color:var(--term-cmd); }
.tat-lk-msg{ min-height:1.2em; color:var(--term-host2); }

@media (max-width:460px){
  .tat-root h1{ font-size:22px; }
  .tat-frames{ grid-template-columns:1fr; gap:48px; }
}
@media (min-width:600px) and (max-width:959px){
  .tat-terminal{ position:fixed; right:20px; bottom:20px; width:300px;
    height:min(360px,calc(100vh - 40px)); margin-top:0;
    box-shadow:6px 6px 0 rgba(20,18,12,.30); z-index:30; }
}
@media (min-width:960px){
  .tat-layout{ max-width:none; display:grid; grid-template-columns:minmax(0,560px) 300px;
    gap:44px; justify-content:center; align-items:start; }
  .tat-terminal{ margin-top:0; position:sticky; top:24px;
    height:calc(100vh - 48px); max-height:620px; min-height:340px; }
}
`;

export default function TeteATete() {
  const [locked, setLocked] = useState(true);
  const [user, setUser] = useState(null);
  const [pw, setPw] = useState("");
  const [denied, setDenied] = useState("");
  const [draft, setDraft] = useState("");
  const [seen, setSeen] = useState({ keena: false, juan: false });
  const [messages, setMessages] = useState([
    { host: "K334A-LAPTOP:/$", gold: false, text: "Hello! xd" },
    { host: "JUAN-SEC-UA-PLATFORM:/$", gold: true, text: "What would Juan say? :)" },
  ]);

  const logRef = useRef(null);
  const msgRef = useRef(null);

  useEffect(() => {
    if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight;
  }, [messages, locked]);

  async function tryUnlock(e) {
    if (e.key !== "Enter") return;
    const u = ACCESS[await sha256(pw)];
    if (u) {
      setUser(u);
      setLocked(false);
      setPw("");
      setDenied("");
      setTimeout(() => msgRef.current && msgRef.current.focus(), 0);
    } else {
      setDenied("Access denied. Try again XD.");
      setPw("");
    }
  }

  function send(e) {
    if (e.key !== "Enter") return;
    const text = draft.trim();
    if (!text || !user) return;
    setMessages((m) => [...m, { host: user.host, gold: user.gold, text }]);
    setDraft("");
    // When you wire up the backend, POST `text` here and let the socket
    // append the other person's replies into `messages`.
  }

  if (locked) {
    return (
      <div className="tat-root">
        <style>{CSS}</style>
        <div className="tat-lock">
          <div className="tat-lk-title">Tête-à-Tête</div>
          <div>Enter your password.</div>
          <div className="tat-lk-prompt">
            <span className="tat-host">AUTH:/$</span>
            <input
              type="password"
              value={pw}
              autoFocus
              autoComplete="off"
              aria-label="Password"
              onChange={(e) => setPw(e.target.value)}
              onKeyDown={tryUnlock}
            />
          </div>
          <div className="tat-lk-msg" role="status">{denied}</div>
        </div>
      </div>
    );
  }

  const promptCls = "tat-host" + (user.gold ? " tat-host2" : "");

  return (
    <div className="tat-root">
      <style>{CSS}</style>
      <div className="tat-layout">
        <main className="tat-page">
          <h1>Tête-à-Tête</h1>

          <section className="tat-intro">
            <p>
              Tête-à-tête is an exclusive, private meeting place between two people.
              It means a place to speak in seclusion, where nobody else can hear what
              you are saying…
            </p>
            <p>
              Anyway, I just wanted to make you feel special.
            </p>
            <p>
              This place is yours, because I built it for you. I want you to add a picture of something. But you can't do it yet! LOL. I won't ask Claude to do it for me, so you'll just have to wait.
            </p>
          </section>

          <section className="tat-frames">
            <article className="tat-moment">
              <div className="tat-canvas">
                <img
                  className="tat-photo"
                  src={`${process.env.PUBLIC_URL}/teteatete.jpg`}
                  alt="Keena"
                />
                <div className="tat-doodle tat-star-big">
                  <svg viewBox="0 0 100 100"><path d={STAR} /></svg>
                </div>
                <div className="tat-doodle tat-star-small">
                  <svg viewBox="0 0 100 100"><path d={STAR2} /></svg>
                </div>
              </div>
              <div className="tat-label">Keena&rsquo;s moment in time</div>
              <button
                className="tat-seen"
                type="button"
                aria-pressed={seen.keena}
                onClick={() => setSeen((s) => ({ ...s, keena: !s.keena }))}
              >
                Seen <span className="tat-box">{seen.keena ? "[x]" : "[ ]"}</span>
              </button>
            </article>

            <article className="tat-moment">
              <div className="tat-canvas">
                <div className="tat-doodle tat-heart-tl">
                  <svg viewBox="0 0 100 100"><path d={HEART} /></svg>
                </div>
                <div className="tat-doodle tat-heart-br">
                  <svg viewBox="0 0 100 100"><path d={HEART} /></svg>
                </div>
              </div>
              <div className="tat-label">Juan&rsquo;s moment in time</div>
              <button
                className="tat-seen"
                type="button"
                aria-pressed={seen.juan}
                onClick={() => setSeen((s) => ({ ...s, juan: !s.juan }))}
              >
                Seen <span className="tat-box">{seen.juan ? "[x]" : "[ ]"}</span>
              </button>
            </article>
          </section>
        </main>

        <section className="tat-terminal" aria-label="Chat">
          <div className="tat-log" ref={logRef}>
            {messages.map((m, i) => (
              <div key={i}>
                <span className={"tat-host" + (m.gold ? " tat-host2" : "")}>{m.host}</span>{" "}
                <span className="tat-cmd">{m.text}</span>
              </div>
            ))}
          </div>
          <div className="tat-entry">
            <span className={promptCls}>{user.host}</span>
            <input
              ref={msgRef}
              type="text"
              value={draft}
              autoComplete="off"
              spellCheck="false"
              maxLength={240}
              aria-label="Type a message"
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={send}
            />
          </div>
        </section>
      </div>
    </div>
  );
}